<template>
  <a :href="href" data-testid="sidebar-logo" @click="$emit('click')">
    <template v-if="src">
      <div class="p-3 -m-3 bg-white dark:bg-zinc-900">
        <img :src="src" class="custom-logo" data-testid="sidebar-logo-custom" />
      </div>
    </template>
    <ImageSvg v-else :name="icon" :class="logoIconClass" />

    <span class="sr-only">Go to the dashboard</span>
  </a>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { ImageSvg } from '@/storybook';

const props = defineProps<{
  src?: string;
  href: string;
  icon: string;
}>();

const logoIconClass = computed(() => (props.icon === 'general.logoWithText' ? 'inline-block w-[130px] h-7' : 'inline-block w-7 h-7'));
</script>
<style scoped>
img.custom-logo {
  max-width: 160px;
  max-height: 36px;
}
</style>
